import './show_tab_switch_component.scss'
import { Controller } from 'stimulus'

export default class extends Controller {
  static classes = ['active']

  connect (): void {
    this.radioElement.addEventListener('change', this.change.bind(this))
    if (this.radioElement.checked === true) {
      this.activate()
    }
  }

  change (event: Event): void {
    this.activate()
    this.otherTabControllers.forEach(controller => controller.deactivate())
  }

  activate (): void {
    this.element.classList.add(this.activeClass)
  }

  deactivate (): void {
    this.element.classList.remove(this.activeClass)
  }

  get otherTabControllers (): Controller[] {
    return this.otherTabElements.map(element => this.application.getControllerForElementAndIdentifier(element, this.identifier))
  }

  get radioElement (): HTMLElement {
    const radioId = this.element.htmlFor
    return document.getElementById(radioId) as HTMLElement
  }

  get otherTabElements (): HTMLElement[] {
    return this.otherRadioElements.map(radioElement => document.querySelector(`label[for="${String(radioElement.id)}"]`) as HTMLElement)
  }

  get otherRadioElements (): HTMLElement[] {
    return Array.from(document.querySelectorAll(`input[name="${String(this.radioElement.name)}"]`)).filter(radioElement => radioElement !== this.radioElement)
  }
}
